import React, { useState } from 'react';
import { Table } from 'antd';
import { Tag } from 'ui';
import { useT } from 'hooks/Locale/useT';
import { TagStatus } from 'ui/Tag/types';
import { config } from 'config/config';
import moment from 'moment';
import CommentModal from '../Modals/CommentModal';

interface SessionsTableInterface {
    data: any[];
}

const SessionsTable: React.FC<SessionsTableInterface> = ({ data }) => {
    const t = useT();
    const [showCommentModal, setShowCommentModal] = useState<any>([]);

    const columns = [
        {
            title: t('general.title'),
            dataIndex: 'title',
        },
        {
            title: t('general.status'),
            dataIndex: 'status',
            render: (status: TagStatus) => (status ? <Tag status={status} /> : null),
        },
        {
            title: t('program.completed_on'),
            dataIndex: 'date',
            render: (date: string | null) =>
                date ? moment(date).format(config.defaultFullDateFormat) : '-',
        },
        {
            title: t('program.result_comment'),
            render: (_text: string, record: { comment?: any[] }) => (
                <div
                    className={record?.comment?.length ? 'pointer' : ''}
                    onClick={() =>
                        record?.comment?.length ? setShowCommentModal(record.comment) : null
                    }
                >
                    <i
                        className={
                            'fa-sharp fa-regular fa-comment-check' +
                            (record?.comment?.length ? '' : ' disabled')
                        }
                    />
                </div>
            ),
        },
    ];

    return (
        <>
            <Table columns={columns} dataSource={data} rowKey={'id'} pagination={{ position: [] }} />
            <CommentModal open={showCommentModal} onCancel={setShowCommentModal} />
        </>
    );
};

export default SessionsTable;
